<template>
  <div class="login-view">
    <div class="login-container">
      <img src="@/assets/mdg-image.png" class="mdg-image" />
      <div class="login-form">
        <h1>登录</h1>
        <h2>欢迎来到{{ title }}管理系统</h2>
        <el-form v-if="mode === 'password'" :model="form" ref="form" :rules="rules">
          <el-form-item prop="login" class="form-item">
            <el-input
              v-model.trim="form.login" @keyup.enter.native="submit"
              placeholder="请输入手机号码 / 账号"
            ></el-input>
            <span slot="error" slot-scope="{error}" class="el-form-item__error">
              <span>{{ error }}</span>
              <template v-if="error === '该手机号码 / 账号未注册'">
                <span class="text-danger">，</span>
                <span @click="loginByWechat" class="register-link">
                  <span>去注册</span>
                  <i class="mdg-icon ico_arrow_right_grayx"></i>
                </span>
              </template>
            </span>
          </el-form-item>
          <el-form-item prop="password" class="form-item">
            <el-input
              v-model="form.password" @keyup.enter.native="submit"
              type="password" placeholder="请输入密码" show-password
            ></el-input>
          </el-form-item>
        </el-form>
        <el-form
          v-if="mode === 'verification'" :model="verificationForm"
          ref="verificationForm" :rules="verificationFormRules"
        >
          <el-form-item prop="mobilePhone" class="form-item">
            <el-input
              v-model.trim="verificationForm.mobilePhone"
              clearable placeholder="请输入手机号码"
            ></el-input>
            <span slot="error" slot-scope="{error}" class="el-form-item__error">
              <span>{{ error }}</span>
              <template v-if="error === '该手机号码未注册'">
                <span class="text-danger">，</span>
                <span @click="loginByWechat" class="register-link">
                  <span>去注册</span>
                  <i class="mdg-icon ico_arrow_right_grayx"></i>
                </span>
              </template>
            </span>
          </el-form-item>
          <el-form-item prop="code" class="form-item">
            <el-input
              v-model.trim="verificationForm.code"
              placeholder="请输入4位短信验证码" class="sms-code-input"
            >
              <el-button
                slot="suffix" @click="sendVerificationCode" type="text"
                :loading="verificationForm.queryCodeLoading" class="sms-code-btn"
                :disabled="
                  verificationForm.timeCount !== 0 ||
                  !/^[1][3-9][0-9]{9}$/.test(verificationForm.mobilePhone)
                "
              >
                <span v-if="verificationForm.queryCodeLoading">发送中</span>
                <span v-else-if="verificationForm.timeCount === 0">
                  {{ verificationForm.queryCodeFirstTime ? '获取短信验证码' : '重发短信验证码' }}
                </span>
                <span v-else>{{ verificationForm.timeCount }} 秒</span>
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button @click="submit" type="primary" class="width-100">登录</el-button>
        <el-row type="flex" justify="space-between" align="middle" class="mt-30 mb-25">
          <el-col :span="8">
            <span @click="loginByWechat" class="wx-login-link">
              <i class="mdg-icon weixin vcenter"></i>
              <a @click.prevent class="vcenter link">微信登录</a>
            </span>
          </el-col>
          <template v-if="mode === 'password'">
            <el-col :span="8">
              <div @click="changeToVerificationMode" class="mode-link text-center">
                手机验证码登录
              </div>
            </el-col>
            <el-col :span="8" class="text-right">
              <a @click.prevent="resetPassword" class="vcenter link">忘记密码？</a>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="8">
              <div @click="changeToPasswordMode" class="mode-link text-right">
                账号密码登录
              </div>
            </el-col>
          </template>
        </el-row>
        <div class="text-center register-hint">
          <span>还没有账号？</span>
          <a @click.prevent="loginByWechat" href="">立即注册</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import qs from 'querystring'
import {
  Form, FormItem,
  Input, Button,
} from 'element-ui'
import * as API from '@/api/auth'
import {
  MAIN_CONTROL_URL, WECHAT_APPID,
  WECHAT_LOGIN_URL, PERSONAL_CENTER_URL,
} from '@/utils/constants'

export default {
  name: 'login-view',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElButton: Button,
  },
  data() {
    return {
      title: '智慧现场',
      mode: 'password',
      form: {
        login: '',
        password: '',
      },
      rules: {
        login: [
          { required: true, message: '请输入手机号码 / 账号' },
          {
            validator: async (rule, value, callback) => {
              const flag = await API.loginAvailable({
                login: value,
              })
              if (flag === true) {
                callback(new Error('该手机号码 / 账号未注册'))
              } else if (flag === false) {
                callback()
              } else {
                callback(new Error('手机号码 / 账号检查失败'))
              }
            },
          },
        ],
        password: [
          { required: true, message: '请输入密码' },
          { min: 6, message: '密码长度至少为6位' },
          { pattern: /^[A-Za-z0-9_]+$/, message: '密码只能包含数字、字母或下划线' },
        ],
      },
      verificationForm: {
        mobilePhone: '',
        code: '',
        timeCount: 0,
        queryCodeFirstTime: true,
        queryCodeLoading: false,
      },
      verificationFormRules: {
        mobilePhone: [
          { required: true, message: '请输入11位手机号码' },
          { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入11位手机号码' },
          {
            validator: async (rule, value, callback) => {
              const flag = await API.loginAvailable({
                login: value,
              })
              if (flag === true) {
                callback(new Error('该手机号码未注册'))
              } else if (flag === false) {
                callback()
              } else {
                callback(new Error('手机号码检查失败'))
              }
            },
          },
        ],
        code: [
          { required: true, message: '请输入4位短信验证码' },
          { pattern: /^[0-9]{4}$/, message: '请输入4位短信验证码' },
        ],
      },
    }
  },
  mounted() {
    this.mode = this.$route.query.mode || 'password'
    if (this.$route.query.title) {
      window.sessionStorage.setItem('mdg-auth-title', this.$route.query.title)
    }
    this.title = window.sessionStorage.getItem('mdg-auth-title') || '智慧现场'
  },
  methods: {
    changeToVerificationMode() {
      this.verificationForm = {
        mobilePhone: '',
        code: '',
        timeCount: 0,
        queryCodeFirstTime: true,
        queryCodeLoading: false,
      }
      this.mode = 'verification'
      this.$router.replace({
        name: 'login-view',
        query: {
          ...this.$route.query,
          mode: 'verification',
        },
      })
      this.$nextTick(() => {
        this.$refs.verificationForm.clearValidate()
      })
    },
    changeToPasswordMode() {
      this.form = {
        login: '',
        password: '',
      }
      this.mode = 'password'
      this.$router.replace({
        name: 'login-view',
        query: {
          ...this.$route.query,
          mode: 'password',
        },
      })
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    async sendVerificationCode() {
      this.verificationForm.queryCodeLoading = true
      const flag = await API.sendVerificationCode({
        mobilePhone: this.verificationForm.mobilePhone,
      })
      this.verificationForm.queryCodeLoading = false
      if (flag) {
        this.verificationForm.timeCount = 60
        this.verificationForm.queryCodeFirstTime = false
        const interval = setInterval(() => {
          this.verificationForm.timeCount -= 1
          if (this.verificationForm.timeCount === 0) {
            clearInterval(interval)
          }
        }, 1000)
      }
    },
    submit() {
      let formRef = null
      let form
      let operate
      if (this.mode === 'password') {
        formRef = this.$refs.form
        form = this.form
        operate = API.login
      } else {
        formRef = this.$refs.verificationForm
        form = this.verificationForm
        operate = API.loginByCode
      }
      formRef.validate(async (valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中...',
          })
          const projectCount = await operate(form)
          loading.close()
          if (_.isNumber(projectCount)) {
            let url = ''
            if (projectCount > 0) {
              url = this.$route.query.url || MAIN_CONTROL_URL
            } else {
              url = PERSONAL_CENTER_URL
            }
            window.location.href = url
          }
        }
      })
    },
    loginByWechat() {
      const url = this.$route.query.url || MAIN_CONTROL_URL
      const redirect = `${WECHAT_LOGIN_URL}?redirect_url=${encodeURIComponent(url)}`
      const query = {
        appid: WECHAT_APPID,
        redirect_uri: redirect,
        scope: 'snsapi_login',
        response_type: 'code',
      }
      const qstr = qs.stringify(query)
      window.location.href = `https://open.weixin.qq.com/connect/qrconnect?${qstr}#wechat_redirect`
    },
    resetPassword() {
      const route = {
        name: 'reset-view',
      }
      if (this.$route.query.url) {
        route.query = {
          url: this.$route.query.url,
        }
      }
      this.$router.push(route)
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variable.scss';

.login-view {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: calc(50vh - 310px) 0;
  background: #f8f9fa;
}
.login-container {
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 1076px;
  height: 620px;
  border-radius:8px;
  background: #fff;
  box-shadow: 0px 60px 140px -60px rgba(53,129,251,0.4);
  overflow: hidden;
}
.mdg-image {
  width: 460px;
  height: 620px;
  background: linear-gradient(296deg,rgba(106,131,255,1) 0%,rgba(53,129,251,1) 100%);
}
.login-form {
  width: 352px;
  margin: 0 auto;
  h1 {
    margin: 16px 0;
    color: $primary;
    font-size: 24px;
    line-height: 33px;
    font-weight: bold;
  }
  h2 {
    margin: 0 0 46px;
    color: #6f83a1;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
  }
  .form-item {
    margin-bottom: 32px;
  }
  .wx-login-link {
    cursor: pointer;
    &:hover .link{
      color: #6F83A1;
    }
  }
  .mdg-icon.weixin {
    font-size: 24px;
    color: $primary;
  }
  .link {
    margin-left: 8px;
    color: #A3B4CC;
    font-size: $text-sm;
    line-height: 20px;
    cursor: pointer;
    &:hover {
      color: #6F83A1;
    }
  }
  .mode-link {
    color: $primary;
    cursor: pointer;
    &:hover {
      color: #0058CE;
    }
  }
  .register-hint {
    color: #A3B4CC;
    font-size: $text-sm;
    a {
      color: $primary;
      text-decoration: none;
      &:hover {
        color: #0058CE;
      }
    }
  }
}
.sms-code-btn, .register-link {
  color: $primary;
  &:hover {
    color: #0E59C7;
  }
  &:active {
    color: darken($primary, 10%);
  }
}
.register-link {
  color: $primary;
  cursor: pointer;
  text-decoration: underline;
  i.mdg-icon {
    font-size: 12px;
  }
}
</style>
